"use strict";

var _interopRequireDefault = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.iterator.some.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _nhanh = require("@/api/nhanh");
var _tour = require("@/api/tour");
var _excel = require("@/views/for-control/excel");
var _lodash = require("lodash");
var _vuePropertyDecorator = require("vue-property-decorator");
var ForControlModal = /*#__PURE__*/function (_Vue) {
  function ForControlModal() {
    var _this;
    (0, _classCallCheck2.default)(this, ForControlModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ForControlModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {});
    (0, _defineProperty2.default)(_this, "loadingButton", false);
    (0, _defineProperty2.default)(_this, "dataTable", []);
    return _this;
  }
  (0, _inherits2.default)(ForControlModal, _Vue);
  return (0, _createClass2.default)(ForControlModal, [{
    key: "isNotSuccess",
    get: function get() {
      return this.dataTable.some(function (e) {
        return e.statusCode != "Success";
      });
    }
  }, {
    key: "transformTable",
    get: function get() {
      return this.dataTable.filter(function (e) {
        return e.statusCode != "Success";
      });
    }
  }, {
    key: "handleSuccessOrder",
    value: function handleSuccessOrder() {
      var shipper = "";
      if (this.form.shippers) {
        shipper = this.form.shippers.map(function (e) {
          return e.name;
        });
      }
      var nextIdsFuture = this.dataTable.map(function (e) {
        return e.orderId;
      });
      var currentId = (0, _lodash.remove)(nextIdsFuture, function (s, i) {
        return i == 0;
      });
      window.open("https://nhanh.vn/order/manage/index?storeId=84054&auto=true&shipper=" + shipper + "&id=" + currentId + "&nextIds=" + nextIdsFuture);
    }
  }, {
    key: "handleSuccessV1Order",
    value: function handleSuccessV1Order() {
      var shipper = "";
      if (this.form.shippers) {
        shipper = this.form.shippers.map(function (e) {
          return e.name;
        });
      }
      var nextIdsFuture = this.dataTable.map(function (e) {
        return e.orderId;
      });
      var currentId = (0, _lodash.remove)(nextIdsFuture, function (s, i) {
        return i == 0;
      });
      window.open("https://v1.nhanh.vn/order/manage/index?storeId=84054&auto=true&shipper=" + shipper + "&id=" + currentId + "&nextIds=" + nextIdsFuture);
    }
  }, {
    key: "handleExportExcel",
    value: function handleExportExcel() {
      // exportExcel({ data: this.dataTable });
    }
  }, {
    key: "handleView",
    value: function () {
      var _handleView = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(data) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.form = data;
              _context.next = 3;
              return this.checkStatusOrder(data);
            case 3:
              this.dataTable = _context.sent;
              if (this.dataTable.some(function (e) {
                return e.statusCode != "Success";
              })) {
                this.visible = true;
              } else {
                if (this.form.id && !this.form.isForControl) {
                  this.updateIsForControl();
                } else if (!this.form.id) {
                  this.$emit("submit:success", this.dataTable);
                }
                (0, _excel.exportExcel)({
                  data: this.dataTable,
                  form: data
                });
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleView(_x) {
        return _handleView.apply(this, arguments);
      }
      return handleView;
    }()
  }, {
    key: "checkStatusOrder",
    value: function () {
      var _checkStatusOrder = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(data) {
        var newData;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              newData = data.orders.map(/*#__PURE__*/function () {
                var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(e) {
                  var res;
                  return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return _nhanh.nhanhApi.findAll({
                          id: e.orderId
                        });
                      case 2:
                        res = _context2.sent;
                        return _context2.abrupt("return", res.data[0]);
                      case 4:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x3) {
                  return _ref.apply(this, arguments);
                };
              }());
              return _context3.abrupt("return", Promise.all(newData));
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function checkStatusOrder(_x2) {
        return _checkStatusOrder.apply(this, arguments);
      }
      return checkStatusOrder;
    }()
  }, {
    key: "updateIsForControl",
    value: function () {
      var _updateIsForControl = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _tour.tourApi.updateForControl(this.form.id);
            case 2:
              this.$emit("submit:success");
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function updateIsForControl() {
        return _updateIsForControl.apply(this, arguments);
      }
      return updateIsForControl;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
ForControlModal = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], ForControlModal);
var _default = exports.default = ForControlModal;